"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lessonSchema = void 0;
const zod_1 = require("zod");
const account_short_1 = require("./account-short");
const lingo2_models_1 = require("lingo2-models");
const image_file_1 = require("./image-file");
const content_stats_1 = require("./content-stats");
const lesson_visit_info_1 = require("./lesson-visit-info");
const __1 = require("..");
exports.lessonSchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  author_id: zod_1.z.string(),
  author: account_short_1.accountShortSchema,
  slug: zod_1.z.string(),
  title: zod_1.z.string(),
  sub_title: zod_1.z.string(),
  type: zod_1.z.nativeEnum(lingo2_models_1.ContentTypeEnum),
  cover_id: zod_1.z.string(),
  cover: image_file_1.imageFileSchema,
  description: zod_1.z.string(),
  language_id: zod_1.z.number(),
  subject_id: zod_1.z.number(),
  level_id: zod_1.z.number(),
  school_id: zod_1.z.string(),
  school: __1.schoolShortSchema,
  created_at: zod_1.z.date(),
  published_at: zod_1.z.date(),
  archived_at: zod_1.z.date(),
  stats: content_stats_1.contentStatsSchema,
  visit_info: lesson_visit_info_1.lessonVisitInfoSchema.optional(),
  moderation_status: zod_1.z.nativeEnum(lingo2_models_1.ModerationStatusEnum),
  moderation_message: zod_1.z.string().optional(),
  promotion: zod_1.z.boolean(),
  promotion_status: zod_1.z.nativeEnum(lingo2_models_1.PromotionStatusEnum),
  advertisement: zod_1.z.boolean(),
  advertisement_status: zod_1.z.nativeEnum(lingo2_models_1.AdvertisementStatusEnum),
  popularity: zod_1.z.number().optional(),
  popularity_by_period: zod_1.z.number().optional(),
  privacy: zod_1.z.nativeEnum(lingo2_models_1.EContentPrivacy),
  privacy_custom_user_ids: zod_1.z.array(zod_1.z.string()).optional(),
  purl: zod_1.z.string().optional(),
  hidden: zod_1.z.boolean().optional(),
  valid: zod_1.z.boolean().optional(),
  readonly: zod_1.z.boolean().optional(),
  collections: zod_1.z.array(__1.collectionSchema).optional(),
  media_url: zod_1.z.string().optional()
});
